export default "__VITE_ASSET__CiawBisp__"